export const FETCH_MOST_POPULAR_SITES = 'fetchMostPopularSites';
export const FETCH_MOST_POPULAR_SITES_WITH_IMAGE = 'fetchMostPopularSitesWithImage';
export const ADD_NEW_MOST_POPULAR_SITE = 'addNewMostPopularSite';
export const REMOVE_MOST_POPULAR_SITE = 'removeMostPopularSite';
export const UPDATE_ACTIVE_SORT_FIELD_MOST_POPULAR_SITES = 'updateActiveSortFieldMostPopularSites';
export const UPDATE_SEARCH_MOST_POPULAR_SITES = 'updateSearchMostPopularSites';
export const CLEAR_SEARCH_MOST_POPULAR_SITES = 'clearSearchMostPopularSites';
